// extracted by mini-css-extract-plugin
export var emailInputBubbleContainer = "_nn-0";